var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('button',[_vm._v(_vm._s(_vm.isShow ? _vm.title : _vm.cover))])])}
var staticRenderFns = []

export { render, staticRenderFns }